export default "__VITE_ASSET__3VqRSYTh__"